// Angular
import { ThrowStmt } from '@angular/compiler';
import { Component, OnInit, Input } from '@angular/core';

// Data/Classes/Interface/Others
import { LicenseIFace } from 'src/app/shared/classes';
import { environment } from '../../../../../environments/environment';


declare var moment: any;
@Component({
  selector: 'app-license-show',
  templateUrl: './license-show.component.html',
  styleUrls: ['./license-show.component.less']
})
export class LicenseShowComponent implements OnInit {
  @Input() license: LicenseIFace;
  private licenseUrl = environment.licenseUrl;

  
  public licenseData = {
    first_name:'',
    last_name : '',
    organization: '',
    email : '',
    phone : '',
    created_at : '',
    expired_date : '',
    app_version:''
  };

  constructor() { }

  ngOnInit() {
    this.setUpLicenseData();
  }

  private setUpLicenseData() {
    this.licenseData.first_name = this.license.data.first_name;
    this.licenseData.last_name = this.license.data.last_name;
    this.licenseData.organization =  this.license.data.organization;
    this.licenseData.email = this.license.data.email;
    this.licenseData.phone = this.license.data.phone;
    this.licenseData.created_at = this.license.data.created_at;
    this.licenseData.expired_date = moment(this.license.data.expired_date).format('DD/MM/YYYY');
    this.licenseData.app_version = this.license.data.app_version;
  }
 
  public downloadLicense(){
     let id = this.license.data.id;
     let url = this.licenseUrl+'/license/download?id='+id;
     window.open(url, "_blank");
  }

}
